import { createContext, useContext, useState, type Dispatch, type SetStateAction } from "react";

type SearchContextType = {
  query: string;
  setQuery: (q: string) => void;
  clear: () => void;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

const SearchContext = createContext<SearchContextType | null>(null);

export function SearchProvider({ children }: { children: React.ReactNode }) {
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const clear = () => {
    setQuery("");
    setIsOpen(false);
  };

  return (
    <SearchContext.Provider
      value={{ query, setQuery, clear, isOpen, setIsOpen }}
    >
      {children}
    </SearchContext.Provider>
  );
}

export const useSearchContext = () => {
  const ctx = useContext(SearchContext);
  if (!ctx) throw new Error("useSearchContext must be used inside provider");
  return ctx;
};
